import { EnvConfig } from './env-config'

export const environment: EnvConfig = {
  env: 'qa2',
  scopeApiUrl: 'https://coreapi.qa2.scope.expert/',
  baseUrl: 'https://qa2.scope.expert',
  baseJsUrl: '',
  production: false,
  baseHost: 'qa2.scope.expert',
}
